<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="85%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"        
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: {},
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      // console.log(id, this.entry);
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_STORAGE_SHELF_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.storageShelf;
          console.log("storage_shelf", this.editableEntry);
          this.extraData = response.data;
          // console.log(this.editableEntry, this.extraData);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(storage) {
      this.pageLoading = true;
      console.log("update", storage);
      this.$apollo
        .mutate({
          mutation: UPDATE_STORAGE_SHELF_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(storage, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateStorageShelf.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
// movementItemAvailableQuantity
const LOAD_STORAGE_SHELF_QUERY = gql `
  query ($id: ID!) { 
    accountContext {
      storageShelf(id: $id) {
        id
        name
        storageId
        storage{
          id
          name
        }
        storageBuildingsAttributes{
          id
          name
          buildingLevelsAttributes{
            id
            name
            buildingLevelBoxesAttributes{
              id
              name
              storageItemLotIdsAttribute
              storageItemLots{
                id
                name
              }
            }
          }
        } 
        validations
      }

      allItemsInStorage {
        id
        name      
        additionalInfo
        secondAdditionalInfo
      }
      allStorages{
        id
        name
        location
      }
    }
  }
`;

const UPDATE_STORAGE_SHELF_MUTATION = gql `
  mutation($input: StorageShelfUpdateInputObject!) {
    updateStorageShelf(input: $input) {
      storageShelf {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>